import { render } from "./A4Data.vue?vue&type=template&id=531634fd&scoped=true"
import script from "./A4Data.vue?vue&type=script&lang=js"
export * from "./A4Data.vue?vue&type=script&lang=js"

import "./A4Data.vue?vue&type=style&index=0&id=531634fd&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531634fd"]])

export default __exports__